// SHIM written by apps/web/scripts/sync-design-system.mjs in place of Hriq's lib/utils.ts:
// the same `cn` and `capitalize`, without `handleError` (Hriq's error reporting + toasts),
// which no copied component uses.
import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));

export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);
